// PosterUploader.jsx
// Reworked poster uploader with live preview and delete support.
// Uses axios directly for multipart upload to avoid JSON header conflict.

import React, { useEffect, useState } from 'react';
import axios from 'axios';

const base = process.env.REACT_APP_BASE_URL || '';

const PosterUploader = ({ onUploaded }) => {
  const [banner1, setBanner1] = useState(null);
  const [banner2, setBanner2] = useState(null);
  const [isUploading, setIsUploading] = useState(false);
  const [preview, setPreview] = useState(null);
  const [msg, setMsg] = useState({ text: '', type: '' });
  const [loadingPreview, setLoadingPreview] = useState(true);

  const fetchPreview = async () => {
    setLoadingPreview(true);
    try {
      const res = await axios.get(`${base}getPosters`);
      setPreview(res.data);
    } catch (err) {
      setPreview(null);
    } finally {
      setLoadingPreview(false);
    }
  };

  useEffect(() => { fetchPreview(); }, []);

  const handleUpload = async (e) => {
    e.preventDefault();
    if (!banner1 || !banner2) {
      setMsg({ text: 'Select both banners', type: 'error' });
      return;
    }

    setIsUploading(true);
    setMsg({ text: '', type: '' });
    const fd = new FormData();
    fd.append('banner1', banner1);
    fd.append('banner2', banner2);

    try {
      const res = await axios.post(`${base}uploadPosters`, fd, {
        headers: { 'Content-Type': 'multipart/form-data' },
      });
      console.log("Uploaded successfully:", res.data);
      setMsg({ text: 'Uploaded successfully', type: 'success' });
      setBanner1(null);
      setBanner2(null);
      fetchPreview();
      if (onUploaded) onUploaded(res.data.poster);
    } catch (err) {
      console.error('upload posters error', err);
      setMsg({ text: err.response?.data?.error || 'Upload failed', type: 'error' });
    } finally {
      setIsUploading(false);
    }
  };

  const handleDelete = async () => {
    // NOTE: backend must implement DELETE /deletePosters to support removal.
    if (!window.confirm('Delete current banners?')) return;
    try {
      await axios.delete(`${base}deletePosters`);
      setMsg({ text: 'Deleted posters', type: 'success' });
      fetchPreview();
    } catch (err) {
      console.error('delete posters error', err);
      setMsg({ text: err.response?.data?.error || 'Delete failed', type: 'error' });
    }
  };

  return (
    <div style={{ padding: 12, border: '1px solid #eee', borderRadius: 6 }}>
      <h3 style={{ marginTop: 0 }}>Manage League Banners</h3>

      <div style={{ display: 'flex', gap: 12, alignItems: 'center', marginBottom: 12 }}>
        {loadingPreview ? (
          <div>Loading banners...</div>
        ) : preview ? (
          <>
            <div style={{ textAlign: 'center' }}>
              <img src={preview.banner1} alt="banner1" style={{ maxHeight: 120 }} />
              <div>Banner 1</div>
            </div>
            <div style={{ textAlign: 'center' }}>
              <img src={preview.banner2} alt="banner2" style={{ maxHeight: 120 }} />
              <div>Banner 2</div>
            </div>
            <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
              <button onClick={fetchPreview} style={{ padding: '6px 8px' }}>Refresh</button>
              {/* <button onClick={handleDelete} style={{ padding: '6px 8px', background: '#d32f2f', color: '#fff', border: 'none' }}>
                Delete Banners
              </button> */}
            </div>
          </>
        ) : (
          <div style={{ color: '#666' }}>No banners uploaded yet</div>
        )}
      </div>

      <form onSubmit={handleUpload} style={{ display: 'flex', gap: 8, alignItems: 'center', flexWrap: 'wrap' }}>
        <div>
          <input type="file" accept="image/*" onChange={(e) => setBanner1(e.target.files[0] ?? null)} />
        </div>
        <div>
          <input type="file" accept="image/*" onChange={(e) => setBanner2(e.target.files[0] ?? null)} />
        </div>
        <div>
          <button type="submit" disabled={isUploading} style={{ padding: '8px 12px' }}>
            {isUploading ? 'Uploading...' : 'Upload Posters'}
          </button>
        </div>
      </form>

      {msg.text && (
        <div style={{
          marginTop: 12,
          padding: 10,
          borderRadius: 6,
          backgroundColor: msg.type === 'error' ? '#ffebee' : '#e8f5e9',
          color: msg.type === 'error' ? '#c62828' : '#2e7d32',
        }}>
          {msg.text}
        </div>
      )}
    </div>
  );
};

export default PosterUploader;
